import { JSONType } from "Typings/Global";
import { Definition } from "./@types";

export const parseDefinition = (data: JSONType): Definition => {
    const {
        id, title, definition, short_description, keywords, full_description, views, examples, authorId,
        tagIds, _picture, created, updated, isPublished, publishDate, slug, tags, og_title
    } = data;

    return {
        id, title, authorId, definition, examples, fullDescription: full_description,
        keywords, shortDescription: short_description, slug, views, picture: _picture,
        created, updated, isPublished, publishDate, tagIds, tags, ogTitle: og_title
    }
}

export const definitionFormToRequestDataMapping = (data: Partial<Definition>) => {
    const { id, definition, title, examples, fullDescription, tagIds, shortDescription, keywords, picture, slug, ogTitle } = data;

    return {
        id, definition, title, examples, full_description: fullDescription, tagIds,
        short_description: shortDescription, keywords, _picture: picture, slug, og_title: ogTitle
    }

}